import { css } from '@repo/pandacss/styled-system/css';
import { type ReactNode } from 'react';

export function getDialogContent(id: string): ReactNode {
  switch (id) {
    case 'hysa_infographic':
      return (
        <>
          <p className={css({ pb: { base: '0', md: '6' } })}>
            Did you know you could earn up to 10x more in interest with a high-yield savings account
            compared to a traditional savings account? Add compound interest to the equation, and
            you'll be on track for exponential, effortless growth.
          </p>
          <p className={css({ textStyle: 'textBold' })}>Here's how it works:</p>
          <ul
            className={css({
              paddingBlockStart: '2',
              paddingBlockEnd: '2',
              paddingLeft: '6',
            })}
          >
            <li className={css({ marginBottom: '2' })}>
              You make an initial deposit into your account. In this illustration, we've assumed an
              amount of $10,000
            </li>
            <li className={css({ marginBottom: '2' })}>
              You let that sum sit in your account for a period of time; in our example, we've used
              5 years
            </li>
            <li className={css({ marginBottom: '2' })}>
              Say you sign up for a high-yield savings account with a bank offering an APY (annual
              percentage yield) of 4.00%, and that rate compounds monthly
            </li>
            <li className={css({ marginBottom: '2' })}>
              Assuming you keep your balance at $10,000 over those 5 years and make no additional
              deposits, you'll earn $2,209.97 in interest! Compare that to only $207.08 earnings
              with a traditional savings account APY of 0.41%
            </li>
          </ul>
          <p>
            You can explore further using NerdWallet's{' '}
            <a
              href="https://www.nerdwallet.com/calculator/compound-interest-calculator"
              rel="noopener noreferrer"
            >
              Compound Interest Calculator.
            </a>
          </p>
        </>
      );
    case 'high_yield_savings_products':
      return (
        <>
          <p className={css({ pb: { base: '0', md: '6' } })}>
            Did you know you could earn up to 10x more in interest with a high-yield savings product
            compared to a traditional savings account? Add compound interest to the equation, and
            you'll be on track for exponential, effortless growth.
          </p>
          <p className={css({ textStyle: 'textBold' })}>Here's how it works:</p>
          <ul
            className={css({
              paddingBlockStart: '2',
              paddingBlockEnd: '2',
              paddingLeft: '6',
            })}
          >
            <li className={css({ marginBottom: '2' })}>
              You make an initial deposit. In this illustration, we've assumed an amount of $10,000
            </li>
            <li className={css({ marginBottom: '2' })}>
              You let that sum sit for a period of time; in our example, we've used 5 years
            </li>
            <li className={css({ marginBottom: '2' })}>
              Say you sign up for a high-yield savings product, offering an APY (annual percentage
              yield) of 4.00%, and that rate compounds monthly
            </li>
            <li className={css({ marginBottom: '2' })}>
              Assuming you keep your balance at $10,000 over those 5 years and make no additional
              deposits, you'll earn $2,209.97 in interest! Compare that to only $207.08 earnings
              with a traditional savings account APY of 0.41%
            </li>
          </ul>
          <p>
            You can explore further using{' '}
            <a
              href="https://www.nerdwallet.com/calculator/compound-interest-calculator"
              rel="noopener noreferrer"
            >
              NerdWallet's Compound Interest Calculator.
            </a>
          </p>
        </>
      );
    default:
      return null;
  }
}
